var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "crud crud-list" },
    [
      _c(
        "grid-component",
        {
          ref: "gridcomponent",
          attrs: {
            data: _vm.gridData,
            columns: _vm.gridColumns,
            extraActions: _vm.extraActions,
            "page-index": _vm.pageIndex,
            "page-size": _vm.pageSize,
            "show-select-checkbox": false,
            showAddNewButton: false,
            showEditItem: false,
            showRemoveItem: false,
            total: _vm.total,
          },
          on: {
            "change-filter-key": _vm.onChangeFilterKey,
            "change-page": _vm.onChangePage,
            "change-sort": _vm.onChangeSort,
            "extra-action": _vm.onExtraAction,
            "gerar-impressao": function ($event) {
              _vm.pags = true
              _vm.tipoDocGerar = 2
            },
            "gerar-pdf": function ($event) {
              _vm.pags = true
              _vm.tipoDocGerar = 1
            },
            "gerar-xls": function ($event) {
              _vm.pags = true
              _vm.tipoDocGerar = 0
            },
          },
        },
        [
          _c(
            "a",
            {
              staticClass: "bg-blue",
              attrs: {
                slot: "more-tools",
                href: "/relatorio-view/12",
                target: "_blank",
                title: _vm.$t(
                  "__.Components.parent.home.fastaction.vendas.list_vue_html.relatorioVendClient"
                ),
              },
              slot: "more-tools",
            },
            [
              _c("i", {
                staticClass: "fa fa-chart-line",
                attrs: { "aria-hidden": "true" },
              }),
            ]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("div", { staticClass: "filtro-lista" }, [
              _c(
                "button",
                {
                  staticClass: "filtro-avancado-button",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      _vm.isHidden = !_vm.isHidden
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("__.Crud.filtroAvancado")) +
                      "\n                    "
                  ),
                  _c("i", { staticClass: "fa fa-caret-down" }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isHidden,
                      expression: "isHidden",
                    },
                  ],
                  staticClass: "drop-lista",
                },
                [
                  _c(
                    "form",
                    {
                      attrs: { novalidate: "novalidate" },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.load($event)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "radio-group",
                          staticStyle: { "margin-bottom": "15px" },
                        },
                        [
                          _c("div", { staticStyle: { display: "table" } }, [
                            _c(
                              "div",
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "control-label",
                                    attrs: { for: "setorId" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm.$t(
                                            "__.Components.parent.home.fastaction.vendas.list_vue_html.setor"
                                          )
                                        ) +
                                        "\n                                    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("combo-component", {
                                  staticStyle: { background: "white" },
                                  attrs: {
                                    id: "setorId",
                                    name: "setorId",
                                    data: _vm.setorOptions,
                                  },
                                  model: {
                                    value: _vm.setorId,
                                    callback: function ($$v) {
                                      _vm.setorId = $$v
                                    },
                                    expression: "setorId",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "control-label",
                                    attrs: { for: "situacao" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm.$t(
                                            "__.Components.parent.home.fastaction.vendas.list_vue_html.situacao"
                                          )
                                        ) +
                                        "\n                                    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("combo-component", {
                                  staticStyle: { background: "white" },
                                  attrs: {
                                    id: "situacao",
                                    name: "situacao",
                                    data: _vm.situacoesVendaOptions,
                                  },
                                  model: {
                                    value: _vm.situacao,
                                    callback: function ($$v) {
                                      _vm.situacao = $$v
                                    },
                                    expression: "situacao",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c("b", [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Components.parent.home.fastaction.vendas.list_vue_html.dtInicEntrega"
                                        )
                                      ) +
                                      "\n                                    "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("date-time-picker-component", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    id: "dataInicial",
                                    name: "dataInicial",
                                  },
                                  model: {
                                    value: _vm.dataInicial,
                                    callback: function ($$v) {
                                      _vm.dataInicial = $$v
                                    },
                                    expression: "dataInicial",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c("b", [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.$t(
                                          "__.Components.parent.home.fastaction.vendas.list_vue_html.dtFinalEntrega"
                                        )
                                      ) +
                                      "\n                                    "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("date-time-picker-component", {
                                  staticStyle: { width: "100%" },
                                  attrs: { id: "dataFinal", name: "dataFinal" },
                                  model: {
                                    value: _vm.dataFinal,
                                    callback: function ($$v) {
                                      _vm.dataFinal = $$v
                                    },
                                    expression: "dataFinal",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "button",
                          {
                            staticClass: "botao-filtrar",
                            attrs: { type: "submit" },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.$t("__.Crud.filtrar")) +
                                "\n                            "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }